<template>
    <div class="has-background-grey-lighter has-text-centered"></div>
</template>

<script>
import qs from 'qs';
export default {
    props: {
        code: { type: String, default: undefined },
        token: { type: String, default: undefined },
        idToken: { type: String, default: undefined },
        access_token: { type: String, default: undefined },
        lb: { type: String, default: undefined },
    },
    watchs: {
        idToken: {
            handler: 'paramHandler',
            immediate: true,
        },
        code: {
            handler: 'paramHandler',
            immediate: true,
        },
    },
    mounted() {
        this.paramHandler();
    },
    methods: {
        paramHandler() {
            const query = qs.parse(
                qs.stringify(this.$route.query, { format: 'RFC1738' }),
                {
                    decoder: (c) => decodeURIComponent(c),
                }
            );
            console.log('IN LOGIN', this.$store.getters.isLoggedIn);
            if (this.$store.getters.isLoggedIn) {
                this.$store.dispatch('logout');
            }
            this.$store
                .dispatch('login', { ...this.$route.params, ...query })
                .then(() => {
                    if (query.lb) {
                        localStorage.setItem('vicensUser', true);
                    }
                    if (null !== localStorage.getItem('currentUri')) {
                        console.log(
                            'Login currentUri exists in localStorage, trying to redirect'
                        );
                        let currentUri = localStorage.getItem('currentUri');
                        localStorage.removeItem('currentUri');
                        this.$router.push({ path: currentUri });
                    } else {
                        this.$router.push({
                            path: '/dashboard',
                            query: {
                                filter: 'mine',
                            },
                        });
                    }
                })
                .catch(() => {
                    this.$router.push({
                        name: 'home',
                    });
                });
        },
    },
};
</script>

<style></style>
